import WithRender from "../../templates/base/preview3D.html";

import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getPreview3D", "get3DPreviewId"])
  },
  methods: {
    ...mapActions(["setPreview3DLoading", "setPrintqChangeProductImage"]),
    onLoad: function () {
      setTimeout(() => {
        this.setPreview3DLoading(false);
      }, 1000);
    },
    printqChangeProductImageEvent: function (event) {
      if (event.detail) {
        this.setPrintqChangeProductImage(event.detail);
      }
    }
  },
  mounted: function () {
    window.document.addEventListener(
      "pqMatrix_set3dPreviewImage",
      this.printqChangeProductImageEvent
    );
  },
  props: ["visible"]
});
